import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ModalComunicado2 from "../../../../components/ModalComunicado2";
import { setOpenModalSubvencoes } from "../../../../store/actions/subvencoes";
import { axios } from "../../../../constants/axiosConfig"; // já configurado com interceptors

import S from "./styles";

const ModalSubvencoes = (props) => {
  const subvencoesReducer = useSelector((state) => state.subvencoes);  
  const dispatch = useDispatch();
  
  const closeModal = () => {
    dispatch(setOpenModalSubvencoes(false));    
  }

  // const handleModal = () => {
  //   dispatch(setOpenModalSubvencoes(false));
  //   //Chamar função para gravar no back esse log 


  //   //Redirecionar para a pagina do
  //   window.location = process.env.REACT_APP_SUBVENCOES_URL;  
  // }

const handleModal = async () => {
   try {
     // Recupera o token JWT da sessão
     const token = sessionStorage.getItem("eRecuperadorJwt");
     // Faz o log de acesso no backend de subvenções
     await axios.post(
       //`${process.env.REACT_APP_SUBVENCOES_URL_API}/logaracesso`,
       `${process.env.REACT_APP_SUBVENCOES_URL_API}/logaracesso`,
        //`https://localhost:5000/api/logaracesso`,
       {},
       {
         headers: {
           Authorization: `Bearer ${token}`,
         },
       }
     );
   } catch (e) {
     // Opcional: tratar erro de log, mas não impedir o fluxo
     console.error("Erro ao logar acesso no backend de subvenções", e);
   }
  dispatch(setOpenModalSubvencoes(false));
  window.location = process.env.REACT_APP_SUBVENCOES_URL;
};

  const handleModalStorage = () =>{
    // dispatch(setOpenModalSubvencoes(false));
    // localStorage.setItem("naoExibirSubvencoesComunicado",true);
    // window.location = process.env.REACT_APP_SUBVENCOES_URL;  
  }

  return (
    subvencoesReducer.openModalSubvencoes && (
<ModalComunicado2 onClose={()=> closeModal()}
        onConfirm={() => handleModal()}
        handleModalStorage={() => handleModalStorage()}
        title="Prezado cliente:"
        buttonText="Estou ciente dessa mensagem"
        // MessageInline="Não exibir mais esta mensagem"
        exclusaoParam={false}
        width={800}
        height={600}
      >
        <S.ModalScroll>
		<br/>
		<b>Atenção!</b>
		<br/>
           Conforme as recentes publicações da Receita Federal (ADI 04/2024 e COSIT 202/2025), para benefícios fiscais relacionados ao ICMS, - tais como redução de base de cálculo, redução de alíquota, isenção, imunidade, diferimento, entre outros - não se aplica o entendimento firmado no EREsp 1.517.492, que excluiu o crédito presumido das bases de cálculo do IRPJ e CSLL. <br/>
           Segundo alegação da Receita em recentes autuações, tais benefícios fiscais não geram acréscimo patrimonial nenhum na empresa. Em julgamento de recursos repetitivos (Tema 1.182), a Primeira Seção do Superior Tribunal de Justiça (STJ) considerou não ser possível excluir benefícios fiscais relacionados ao ICMS - como redução de base de cálculo, redução de alíquota, isenção, imunidade, diferimento, entre outros - das bases de cálculo do IRPJ e CSLL, salvo quando atendidos os requisitos previstos no artigo da Lei Complementar 160/2017 e no artigo 30 da Lei 12.973/2014.<br/>
           Orientamos que para realizar exclusão dos benefícios fiscais mencionados, consulte sua assessoria contábil ou jurídica.<br/>
           O módulo de Subvenções do e-Recuperador automatiza a identificação de receitas de subvenção de investimento oriundas de benefícios fiscais de ICMS capturados nos arquivos EFD ICMS/IPI, conforme a legislação da Lei Complementar 160/2017 e no artigo 30 da Lei 12.973/2014. <br/>
		<br/>
		<b>Importante destacar que o sistema:</b>
		<ul>
			<li>não avalia a finalidade econômica da subvenção,</li>
			<li>não valida se o benefício foi utilizado para assegurar a viabilidade do empreendimento, </li>
			<li>não verifica conformidade contábil da escrituração, e </li>
			<li>não analisa requisitos formais de concessão do benefício (Convênio 190/2017). </li>
		</ul>
		<br/>
		<b> Cabe ao usuário avaliar:</b>
		<ul>
			<li>efetiva concessão do benefício utilizado: comprovando que a empresa está dentro do direito de usufruir do mesmo, a observância do art.10 da LC 160/2017 e Convênio ICMS 190/2017 (registro e depósito no CONFAZ): demonstrando que o beneficio utilizado é válido, </li>
			<li>o tratamento contábil conforme CPC 07: reconhecimento integral da despesa em contrapartida a receita de subvenção,  </li>
			<li>a constituição da Reserva de Incentivos Fiscais: atendendo ao previsto no art. 30 da Lei 12.973. </li>
		</ul>
		<br/>
          A análise de eventuais questionamentos da Receita Federal não integra o escopo do sistema, essas verificações são de responsabilidade exclusiva do contador/consultor e do departamento jurídico do contribuinte.
          <br/>
		</S.ModalScroll>
</ModalComunicado2>
    )
  );
};

export default ModalSubvencoes;
